import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

const copy = {
  en: {
    title: 'Clinical Safety & Responsible AI Use',
    items: [
      'AI supports clinical workflows but does not replace veterinary judgement',
      'All AI-generated outputs require review and approval by a qualified veterinarian',
      'The system is designed for human oversight and auditability',
      'Privacy and data minimisation principles guide system architecture',
      'Responsible deployment and clinician control remain central to the platform',
    ],
  },
  uk: {
    title: 'Клінічна безпека та відповідальне використання AI',
    items: [
      'AI підтримує клінічні процеси, але не замінює судження ветеринара',
      'Усі результати, згенеровані AI, потребують перегляду та схвалення кваліфікованим ветеринаром',
      'Система розроблена з урахуванням людського нагляду та аудиторської прозорості',
      'Принципи приватності та мінімізації даних визначають архітектуру системи',
      'Відповідальне впровадження та контроль лікаря залишаються в основі платформи',
    ],
  },
  ja: {
    title: '臨床安全性と責任あるAI活用',
    items: [
      'AIは臨床ワークフローを支援しますが、獣医師の判断を置き換えるものではありません',
      'AIが生成したすべての出力は、有資格獣医師によるレビューと承認が必要です',
      'システムは人による監督と監査可能性を前提に設計されています',
      'プライバシーとデータ最小化の原則がシステム設計の指針です',
      '責任ある導入と臨床医によるコントロールがプラットフォームの中核に位置づけられています',
    ],
  },
};

export default function SafetySection() {
  const { lang } = useLanguage();
  const c = copy[lang];

  return (
    <section className="section-padding section-alt">
      <div className="container-max max-w-4xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-foreground text-center mb-10"
        >
          {c.title}
        </motion.h2>
        <ul className="space-y-2.5">
          {c.items.map((text, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="flex gap-3 items-start card-elevated p-4"
            >
              <ShieldCheck size={18} className="text-primary shrink-0 mt-0.5" />
              <p className="text-sm text-foreground/90 leading-relaxed">{text}</p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
